import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

let deepLinkInitialized = false;

export function useDeepLink() {
  const navigate = useNavigate();

  useEffect(() => {

    if (deepLinkInitialized) return;
    deepLinkInitialized = true;

    if (!Capacitor.isNativePlatform()) {
      return;
    }

    const handleUrl = (url?: string) => {
      if (!url) return;

      try {
        const parsed = new URL(url);

        if (parsed.searchParams.has('code')) {
          const path = '/' + parsed.search;
          window.history.replaceState(null, '', path);
          navigate('/');
        } 
      } catch (err) {
        console.error('[DeepLink] Erreur parsing URL', err);
      }
    };

    App.getLaunchUrl().then((launch) => handleUrl(launch?.url));

    App.addListener('appUrlOpen', ({ url }) => handleUrl(url));

  }, [navigate]);
}